<template>
  <div>
    <!-- 样式对齐收入合同审批（con_register）：蓝色图标区块标题 + 6列网格面板 -->
    <div class="header">
      <img :src="icon1" alt="" />
      <span>基本信息</span>
    </div>

    <div class="panel">
      <div class="label">工单编号</div>
      <div class="value1">{{ extra.orderNo || "—" }}</div>
      <div class="label">优先级</div>
      <div class="value2">{{ priorityName }}</div>

      <div class="label">工单类型</div>
      <div class="value1">{{ extra.workType || "—" }}</div>
      <div class="label">涉及模块</div>
      <div class="value2">{{ extra.workModule || "—" }}</div>

      <div class="label">申请分类</div>
      <div class="value1">{{ extra.applyCategory || "—" }}</div>
      <div class="label">提交时间</div>
      <div class="value2">{{ formatTime(extra.createAt) }}</div>

      <div class="label">工单标题</div>
      <div class="value3">{{ extra.title || "—" }}</div>

      <div class="label">具体描述</div>
      <div class="value3 pre-wrap">{{ extra.description || "—" }}</div>

      <div class="label">上传附件</div>
      <div class="value3">
        <template v-if="applyFiles.length > 0">
          <div v-for="item in applyFiles" :key="item.id || item.completePath">
            <a :href="item.completePath" target="_blank" download>{{ item.name }}</a>
          </div>
        </template>
        <span v-else>—</span>
      </div>

      <div class="label">申请人</div>
      <div class="value1">{{ extra.applicantName || "—" }}</div>
      <div class="label">申请部门</div>
      <div class="value2">{{ extra.deptName || "—" }}</div>
    </div>

    <div class="header">
      <img :src="icon2" alt="" />
      <span>处理人信息</span>
    </div>

    <div class="panel">
      <div class="label">处理人姓名</div>
      <div class="value1">{{ handlerNamesText }}</div>
      <div class="label">处理部门</div>
      <div class="value2">{{ extra.handlerDeptName || "—" }}</div>
    </div>

    <!-- 处理记录：表单常显；仅处理人节点（task_process/task_transfer_process且非disabled）放开编辑，
         其他人灰显（disabled表单），展示已保存记录值 -->
    <div class="header">
      <img :src="icon3" alt="" />
      <span>处理记录</span>
    </div>

    <div class="panel">
      <div class="label">问题类型</div>
      <div class="value1">
        <a-radio-group
          :disabled="!editable"
          :value="recordProblemType"
          @change="(e) => setRecord({ problemType: e.target.value })"
        >
          <a-radio value="demand">需求</a-radio>
          <a-radio value="bug">故障</a-radio>
        </a-radio-group>
      </div>

      <!-- 是否收费：仅工单处理人节点（task_process，精确匹配）可编辑，其余节点只读展示已保存值；
           且仅限oa_work_order流程的设备报修工单；提交时随map携带is_charge供BPMN收费/不收费网关分支使用，回调入库 -->
      <div class="label col-start-1" v-if="isChargeVisible">是否收费</div>
      <div class="value1" v-if="isChargeVisible">
        <a-checkbox
          v-if="isChargeEditable"
          :checked="workOrderRecord.isCharge === true"
          @change="(e) => setRecord({ isCharge: e.target.checked })"
        >
          收费
        </a-checkbox>
        <template v-else>{{ recordIsCharge }}</template>
      </div>

      <div class="label col-start-1">修改内容</div>
      <div class="value3">
        <a-textarea
          :disabled="!editable"
          :value="recordModifyContent"
          @change="(e) => setRecord({ modifyContent: e.target.value })"
          placeholder="请输入修改内容"
          :auto-size="{ minRows: 3 }"
          :max-length="2000"
        />
      </div>

      <div class="label">补充附件</div>
      <div class="value3">
        <Uploader
          v-if="editable"
          :list="workOrderRecord.files"
          @change="(arr) => setRecord({ files: arr })"
        />
        <template v-else>
          <div v-for="item in processFiles" :key="item.id || item.completePath">
            <a :href="item.completePath" target="_blank" download>{{ item.name }}</a>
          </div>
          <span v-if="processFiles.length === 0">—</span>
        </template>
      </div>
    </div>

    <!-- 旧只读面板（表单常显改造前），按惯例注释保留
    <div class="panel" v-else-if="hasProcessRecord">
      <div class="label">问题类型</div>
      <div class="value1">{{ problemTypeName }}</div>
      <div class="label">处理人</div>
      <div class="value2">{{ handlerNamesText }}</div>

      <div class="label">修改内容</div>
      <div class="value3 pre-wrap">{{ extra.modifyContent || "—" }}</div>

      <div class="label">补充附件</div>
      <div class="value3">
        <template v-if="processFiles.length > 0">
          <div v-for="item in processFiles" :key="item.id || item.completePath">
            <a :href="item.completePath" target="_blank" download>{{ item.name }}</a>
          </div>
        </template>
        <span v-else>—</span>
      </div>
    </div>
    -->
    <Padding />
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import Uploader from "@/components/uploader";

export default {
  components: { Uploader },
  props: {
    // 直接传入工单数据（工单详情页用）；不传则从审批详情store读取
    order: { type: Object, default: null },
  },
  data() {
    return {
      // 复用收入合同审批的区块图标，保证样式一致
      icon1: require("@/assets/contract-register/icon-info.png"),
      icon2: require("@/assets/contract-register/icon-project.png"),
      icon3: require("@/assets/contract-register/icon-file.png"),
    };
  },
  computed: {
    ...mapState("approval", ["detail", "workOrderRecord"]),
    ...mapGetters("approval", ["disabled", "isOaWorkOrder"]),
    extra() {
      if (this.order) {
        return this.order;
      }
      return this.detail && this.detail.extra ? this.detail.extra : {};
    },
    // 工单处理人节点（含转单后节点）可编辑处理记录
    editable() {
      if (!this.order) {
        const key = this.detail.taskDefinitionKey;
        return !this.disabled && (key === "task_process" || key === "task_transfer_process");
      }
      return false;
    },
    // 是否收费：仅工单处理人节点（task_process，精确匹配）可编辑（转单节点不涉及），
    // 且仅限oa_work_order流程、工单类型为"设备报修"的工单
    isChargeEditable() {
      if (!this.order && this.isOaWorkOrder && this.extra.workType === "设备报修") {
        return !this.disabled && this.detail.taskDefinitionKey === "task_process";
      }
      return false;
    },
    // 是否收费行显示条件：工作流为oa_work_order且工单类型为"设备报修"
    //（工单详情页order模式无审批store上下文，工单管理均为oa_work_order流程，按工单类型判断）；
    // 处理节点可编辑，其余节点仅在已保存值时只读展示
    isChargeVisible() {
      const isWorkOrderProc = this.order || this.isOaWorkOrder;
      if (!isWorkOrderProc || this.extra.workType !== "设备报修") {
        return false;
      }
      return this.isChargeEditable || typeof this.extra.isCharge === "boolean";
    },
    // 是否收费展示值：可编辑取store（当前填写），只读灰显取extra（已保存值）
    recordIsCharge() {
      const value = this.isChargeEditable
        ? this.workOrderRecord.isCharge
        : this.extra.isCharge;
      return value === true ? "是" : value === false ? "否" : "—";
    },
    priorityName() {
      const map = { common: "普通", urgent: "紧急" };
      return map[this.extra.priority] || this.extra.priority || "—";
    },
    // 处理记录表单值：可编辑时取store（当前填写），只读灰显时取extra（已保存记录）
    recordProblemType() {
      return this.editable ? this.workOrderRecord.problemType : this.extra.problemType;
    },
    recordModifyContent() {
      return this.editable ? this.workOrderRecord.modifyContent : this.extra.modifyContent;
    },
    // 处理人姓名（可能为逗号分隔多人），展示为顿号分隔
    handlerNamesText() {
      const text = (this.extra.handlerName || "")
        .split(/[,，]/)
        .map((item) => item.trim())
        .filter(Boolean)
        .join("、");
      return text || "—";
    },
    problemTypeName() {
      const map = { demand: "需求", bug: "故障" };
      return map[this.extra.problemType] || this.extra.problemType || "—";
    },
    // 申请附件：extra中为文件列表（FileVo，库中存文件id列表）；兼容旧实例extra中的URL-JSON格式
    applyFiles() {
      if (this.extra.attachmentList && this.extra.attachmentList.length > 0) {
        return this.extra.attachmentList;
      }
      return this.parseFiles(this.extra.attachment);
    },
    // 处理记录附件
    processFiles() {
      if (this.extra.processAttachmentList && this.extra.processAttachmentList.length > 0) {
        return this.extra.processAttachmentList;
      }
      return this.parseFiles(this.extra.processAttachment);
    },
    hasProcessRecord() {
      return !!(
        this.extra.problemType ||
        this.extra.modifyContent ||
        (this.extra.processAttachmentList && this.extra.processAttachmentList.length > 0) ||
        this.extra.processAttachment
      );
    },
  },
  methods: {
    moment,
    setRecord(payload) {
      this.$store.commit("approval/setWorkOrderRecord", payload);
    },
    formatTime(time) {
      return time ? moment(time).format("YYYY-MM-DD HH:mm") : "—";
    },
    parseFiles(raw) {
      if (!raw) return [];
      try {
        const arr = JSON.parse(raw);
        if (Array.isArray(arr)) {
          return arr.map((item) =>
            typeof item === "string"
              ? { completePath: item, name: this.$getFileName(item) }
              : item
          );
        }
      } catch (e) {
        // 兼容逗号分隔的纯路径格式
        return raw
          .split(",")
          .filter(Boolean)
          .map((item) => ({ completePath: item, name: this.$getFileName(item) }));
      }
      return [];
    },
  },
};
</script>

<style lang="less" scoped>
/* 面板样式与 contract-register 保持一致 */
.panel {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #e8e8e8;

  & > div {
    padding: 8px;
    border-bottom: 1px solid #e8e8e8;
  }

  .label {
    font-weight: bold;
    background-color: #fafafa;
    border-right: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
  }

  // 强制从第1列开始（起新行），用于单独成行的字段label
  .col-start-1 {
    grid-column-start: 1;
  }

  .value1 {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  .value2 {
    grid-column-start: 5;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .value3 {
    grid-column-start: 2;
    grid-column-end: 7;
    border-right: 1px solid #e8e8e8;
  }

  .pre-wrap {
    white-space: pre-wrap;
    word-break: break-all;
  }
}

.header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  margin-top: 12px;
  color: #1890ff;
  font-weight: bold;
  font-size: 14px;

  img {
    width: 14px;
    margin-right: 4px;
  }
}
</style>
